<template>
  <div class="wrapper">
    <Menu />
    <Header title="İletişim" hideMore />
    <div
      class="body-area pt70"
      style="min-height: -webkit-fill-available; display: flex; flex: 1; align-items: center; justify-content: center; flex-direction: column; padding: 0px 25px; padding-bottom: 150px; padding-top: 100px"
    >
      <input type="text" v-model="form.firstname" class="form-input" placeholder="Ad" />

      <input type="text" v-model="form.lastname" class="form-input" placeholder="Soyad" />

      <input type="text" v-model="form.email" class="form-input" placeholder="E-Mail" />

      <input type="text" v-model="form.phone" class="form-input" placeholder="Telefon" />

      <select name id class="form-input" v-model="form.city">
        <option value>Şehir</option>
        <option :value="item.id" v-for="item in cities">{{item.name}}</option>
      </select>

      <select name id class="form-input" v-model="form.subject">
        <option value>Konu</option>
        <option :value="item.name" v-for="item in subjects">{{item.name}}</option>
      </select>

      <textarea
        name
        id
        v-model="form.message"
        cols="30"
        rows="10"
        class="form-input"
        placeholder="Mesajınız..."
      ></textarea>

      <button class="confirm-button" @click="send">Gönder</button>

      <ol>
        <li style="color: red; font-weight: bold; font-size: 12px" v-for="item in errors">{{item}}</li>
      </ol>
    </div>
    <Footer />
  </div>
</template>


<script>
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import Menu from "@/components/Menu";
import axios from "axios";
export default {
  name: "Activate",
  components: {
    Footer,
    Menu,
    Header
  },
  data() {
    return {
      cities: [],
      subjects: [],
      form: {
        email:
          this.$store.state.user != null ? this.$store.state.user.email : "",
        subject: "",
        firstname:
          this.$store.state.user != null
            ? this.$store.state.user.first_name
            : "",
        lastname:
          this.$store.state.user != null
            ? this.$store.state.user.last_name
            : "",
        message: "",
        phone:
          this.$store.state.user != null
            ? this.$store.state.user.phone_gsm
            : "",
        city: this.$store.state.user != null ? this.$store.state.user.city : ""
      },
      errors: []
    };
  },
  methods: {
    send() {
      this.errors = [];
      var data = new FormData();
      Object.keys(this.form).map((item, index) => {
        data.append(item, this.form[item]);
      });

      axios
        .post("iletisim", data)
        .then(res => {
          if (res.data.type == "error") {
            alert(res.data.message);
            this.errors = res.data.message;
          } else {
            alert(res.data.message);
            this.$router.back();
          }
        })
        .catch(err => {
          alert("Sunucu Hatasi");
        });
    }
  },
  beforeMount() {
    axios.post("statik/il-listesi").then(res => {
      this.cities = res.data;
    });

    axios.post("statik/iletisim-konu").then(res => {
      this.subjects = res.data;
    });
  }
};
</script>


// WEBPACK FOOTER //
// src/pages/Contact.vue